import React, { useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';

const IconClone = ({
    disabled = false,
    onClick,
    style,
    size = 50,
    fill,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            height={size}
            viewBox='0 0 48.437 50'
            xmlns='http://www.w3.org/2000/svg'
            fill={disabled ? '#cccccc' : fill}
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...buildSvgEvents(ref, disabled, onClick, fill)}
            {...props}
        >
            <g strokeWidth={0.789}>
                <path d='M48.437 35.925V15.638c0-3.044-2.155-4.946-4.945-4.946-9.383.127-18.766.127-28.276 0-2.917 0-4.945 2.283-4.818 4.946.126 9.763.126 19.4 0 29.163 0 2.536.887 4.185 3.17 5.199H45.14c2.41-1.141 3.297-3.043 3.17-5.58 0-2.916.127-5.705.127-8.495zm-3.423 8.75c0 1.521-.254 1.648-1.649 1.648H15.343c-1.142 0-1.649-.38-1.649-1.522V15.638c0-1.142.38-1.649 1.522-1.649h28.15c1.394 0 1.52.254 1.52 1.649v14.455c.128 4.945.128 9.763.128 14.581z' />
                <path d='M4.945 35.799c-1.014 0-1.521-.38-1.521-1.395V4.86c0-1.015.38-1.395 1.394-1.395h28.403c1.015 0 1.395.38 1.395 1.395v3.93h3.424V5.24c0-3.55-1.776-5.199-5.2-5.199H5.834C2.916-.212 1.014.675 0 3.465v32.334c1.775 3.803 3.424 3.677 8.496 3.296V35.8c-1.268 0-2.41-.127-3.55 0z' />
            </g>
        </svg>
    );
};

export default IconClone;
